// routes
import useStateRoutes from "../components/hooks/useStateRoutes";
import StateRoutes from "./StateRoutes";

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useStateRoutes(StateRoutes);
}
